$(document).ready(function() {


  // MIESZKANIA
  $("#app table").stickyTableHeaders();




  // END MIESZKANIA


  $('.page-lokalizacja__mapa .icons-map img').attr("data-aos","fade-down");
  $('.page-lokalizacja__mapa .icons-map img').attr("data-aos-duration","800");
  $('.page-lokalizacja__mapa .icons-map img').attr("data-aos-delay","400");


  // AOS
  AOS.init();

  if($(window).width() < 992){
    AOS.init({
      disable: true,
    });
  }

// SELECT HOME
$('.js-example-basic-single').select2({
    minimumResultsForSearch: Infinity,
});





  // MATCH HEIGHT
  $('.page-inwestycja .boxs__items--item').matchHeight();

  //
  // ─── NAVIGATION TOGGLE ──────────────────────────────────────────────────────────
  //


  var hamburger = document.querySelector(".hamburger");
  hamburger.addEventListener("click", function() {
    hamburger.classList.toggle("is-active");
  });

  //
  // ─── OWL CAROUSEL ───────────────────────────────────────────────────────────────
  //

 var bigimage = $("#big");
  var thumbs = $("#thumbs");
  //var totalslides = 10;
  var syncedSecondary = true;

  bigimage
    .owlCarousel({
    items: 1,
    slideSpeed: 5000,
    nav: false,
    autoplay:false,
    dots: false,
    loop: true,
    responsiveRefreshRate: 600,
    navText: [
      '<i class="fa fa-arrow-left" aria-hidden="true"></i>',
      '<i class="fa fa-arrow-right" aria-hidden="true"></i>'
    ]
  })
    .on("changed.owl.carousel", syncPosition);

  thumbs
    .on("initialized.owl.carousel", function() {
    thumbs
      .find(".owl-item")
      .eq(0)
      .addClass("current");
  })
    .owlCarousel({
    items: 4,
    dots: false,
    nav: true,
    navText: [
      '<i class="fa fa-chevron-left" aria-hidden="true"></i>',
      '<i class="fa fa-chevron-right" aria-hidden="true"></i>'
    ],
    smartSpeed: 200,
    slideSpeed: 500,
    slideBy: 4,
    responsiveRefreshRate: 100
  })
    .on("changed.owl.carousel", syncPosition2);

  function syncPosition(el) {
    //if loop is set to false, then you have to uncomment the next line
    //var current = el.item.index;

    //to disable loop, comment this block
    var count = el.item.count - 1;
    var current = Math.round(el.item.index - el.item.count / 2 - 0.5);

    if (current < 0) {
      current = count;
    }
    if (current > count) {
      current = 0;
    }
    //to this
    thumbs
      .find(".owl-item")
      .removeClass("current")
      .eq(current)
      .addClass("current");
    var onscreen = thumbs.find(".owl-item.active").length - 1;
    var start = thumbs
    .find(".owl-item.active")
    .first()
    .index();
    var end = thumbs
    .find(".owl-item.active")
    .last()
    .index();

    if (current > end) {
      thumbs.data("owl.carousel").to(current, 100, true);
    }
    if (current < start) {
      thumbs.data("owl.carousel").to(current - onscreen, 100, true);
    }
  }

  function syncPosition2(el) {
    if (syncedSecondary) {
      var number = el.item.index;
      bigimage.data("owl.carousel").to(number, 100, true);
    }
  }

  thumbs.on("click", ".owl-item", function(e) {
    e.preventDefault();
    var number = $(this).index();
    bigimage.data("owl.carousel").to(number, 300, true);
  });

  $(".banner-slider .owl-carousel").owlCarousel({
    nav: true,
    navText: ["<i class='fa fa-chevron-left'></i>","<i class='fa fa-chevron-right'></i>"],
    items: 1,
    smartSpeed: 10000,
    dots:false,
    singleItem: true,
    animateIn: 'fadeIn',
    animateOut: 'fadeOut',
    pagination: false,
    autoplay:true,
    autoplayTimeout: 5000,
    autoplayHoverPause: false,
    loop: true,
    mouseDrag: false,
  });
  // $(".main-carousel").owlCarousel({
  //   loop: true,
  //   // margin: 10,
  //   lazyLoad: true,
  //   nav: true,
  //   dots: true,
  //   // dotsContainer: '#carousel-custom-dots',
  //   navText: ["<span></span>", "<span></span>"],
  //   autoplay: false,
  //   animateIn: "fadeIn",
  //   animateOut: "fadeOut",
  //   responsive: {
  //     0: {
  //       items: 1
  //     },
  //     768: {
  //       items: 2
  //     },
  //     991: {
  //       items: 3
  //     },
  //     1200: {
  //       items: 4
  //     }
  //   }
  // });



  $('.page-lokalizacja__mapa').click(function (event) {

    var x = event.offsetX,
        y = event.offsetY,    
        xPx = x + "px",
        yPx = y + "px";

    console.log(x,y);

    // var train = $('.page-lokalizacja__mapa').append( "<div class="train"></div>");

    // train.css()
    
    // $('.page-lokalizacja__mapa').append( "<div id='icon'></div>");
    // var icon = $('#icon');
    // icon.css('top' , xPx);
    // icon.css('left', yPx);



});

}); //end $


// select serach front pages

$(document).ready(function () {
  var str = $('#pokoje').val().replace('pokoj-dowolna', '').replace('pokoje', '').replace('pokoje', '').replace('pokoj', '').replace('pokoi', '');
  $('#roomsmin').val(str);
  $('#roomsmax').val(str);
  str = $('#powierzchnia').val().replace('powierzchnia-dowolna', '').replace('od ', '').replace(' m2', '').replace('pow. ', '').split("-");
  $('#areamin').val(str[0]);
  $('#areamax').val(str[1]);
  str = $('#pietro').val().replace('pietro-dowolna', '').replace('pietro', '').replace('parter', '0');
  $('#levelmin').val(str);
  $('#levelmax').val(str);
  str = $('#budynek').val().replace('budynek-dowolna', '').replace('budynek', '');
  $('#building').val(str);
  str = $('#cena').val().replace('cena-dowolna', '').replace(' tys. zł', '').replace('do ', '').replace('pow. ', '').split("-");
  if ($('#cena').val().search('do ') >= 0) {
      $('#pricemin').val('');
      $('#pricemax').val(str[0]);
  }
  else {
      $('#pricemin').val(str[0]);
      $('#pricemax').val(str[1]);
  }
});
$('#pokoje').change(function (e) {
  var str = $('#pokoje').val().replace('powierzchnia-dowolna', '').replace('pokoje', '').replace('pokoje', '').replace('pokoj', '').replace('pokoi', '');
  $('#roomsmin').val(str);
  $('#roomsmax').val(str);
});
$('#powierzchnia').change(function (e) {
  var str = $('#powierzchnia').val().replace('od ', '').replace(' m2', '').replace('powierzchnia-dowolna', '').replace('pow. ', '').split("-");
  $('#areamin').val(str[0]);
  $('#areamax').val(str[1]);
});
$('#pietro').change(function (e) {
  var str = $('#pietro').val().replace('pietro', '').replace('pietro-dowolna', '').replace('parter', '0');
  $('#levelmin').val(str);
  $('#levelmax').val(str);
});
$('#budynek').change(function (e) {
  var str = $('#budynek').val().replace('budynek-dowolna', '').replace('budynek', '');
  $('#building').val(str);
});
$('#cena').change(function (e) {
  var str = $('#cena').val().replace('cena-dowolna', '').replace(' tys. zł', '').replace('do ', '').replace('pow. ', '').split("-");
  if ($('#cena').val().search('do ') >= 0) {
      $('#pricemin').val('');
      $('#pricemax').val(str[0]);
  }
  else {
      $('#pricemin').val(str[0]);
      $('#pricemax').val(str[1]);
  }
});

// MAPA LOKALIZACJA
  





